import React, { Component } from "react";
import { connect } from "react-redux";
import { setDeveloperOverride } from "../../actions/developerOverrideActions";

import { LabeledDropDownSelect } from "../DropDownSelect";

import lxwConstants from "../../config/lexworkplace-constants";
import frontendConfig from "../../config/legalworks.frontend.config.json";
import { shouldShowDeveloperMessages } from "../../reducers/developerOverridesReducer";
import { showAsDeveloperMessage } from "./showAsDeveloperMessage";
const availableDeveloperOverrides = lxwConstants.availableDeveloperOverrides;

const bulkDownloadOverrideOptions = Object.keys(
	availableDeveloperOverrides.bulkDownloadServerAuthority.options
).map((key) => {
	return {
		value: key,
		label: availableDeveloperOverrides.bulkDownloadServerAuthority.options[
			key
		].display,
	};
});

const showDeveloperMessagesOptions = Object.keys(
	availableDeveloperOverrides.showDeveloperMessages.options
).map((key) => {
	return {
		value: key,
		label: availableDeveloperOverrides.showDeveloperMessages.options[key]
			.display,
	};
});

const overrideFrontendUserRightsOptions = Object.keys(
	availableDeveloperOverrides.overrideFrontendUserRights.options
).map((key) => {
	return {
		value: key,
		label: availableDeveloperOverrides.overrideFrontendUserRights.options[
			key
		].display,
	};
});

const ignoreLifecycleStatusOptions = Object.keys(
	availableDeveloperOverrides.ignoreLifecycleStatus.options
).map((key) => {
	return {
		value: key,
		label: availableDeveloperOverrides.ignoreLifecycleStatus.options[key]
			.display,
	};
});

class DeveloperOverridesSettings extends Component {
	constructor(props) {
		super(props);

		this.state = {
			throwTestError: false,
		};

		this.handleChange = this.handleChange.bind(this);
		this.handleTriggerTestError = this.handleTriggerTestError.bind(this);
	}

	handleTriggerTestError(e) {
		e.preventDefault();
		this.setState({ throwTestError: true });
	}
	getDefaultBulkDownloadOverrideDropdownValue() {
		const matchingOption = bulkDownloadOverrideOptions.find(
			(option) =>
				option.value ===
				this.props.developerOverrides.bulkDownloadServerAuthority
		);
		if (matchingOption) {
			return matchingOption;
		} else {
			return [];
		}
	}

	getDefaultDevloperMessageDropdownValue() {
		const matchingOption = showDeveloperMessagesOptions.find(
			(option) =>
				option.value ===
				this.props.developerOverrides.showDeveloperMessages
		);
		if (matchingOption) {
			return matchingOption;
		}
		return [];
	}

	getDefaultOverrideFrontendUserRightsDropdownValue() {
		const matchingOption = overrideFrontendUserRightsOptions.find(
			(option) =>
				option.value ===
				this.props.developerOverrides.overrideFrontendUserRights
		);
		if (matchingOption) {
			return matchingOption;
		}
		return [];
	}

	getDefaultIgnoreLifecycleStatusDropdownValue() {
		const matchingOption = ignoreLifecycleStatusOptions.find(
			(option) =>
				option.value ===
				this.props.developerOverrides.ignoreLifecycleStatus
		);
		if (matchingOption) {
			return matchingOption;
		}
		return [];
	}

	handleChange(key, dropdownSelection) {
		if (dropdownSelection && dropdownSelection.value) {
			this.props.setDeveloperOverride(key, dropdownSelection.value);
		} else {
			this.props.setDeveloperOverride(key, "OVERRIDE_DISABLED");
		}
	}

	render() {
		if (this.state.throwTestError) {
			throw new Error(
				"Test error triggered from the Developer Overrides page"
			);
		}

		const sectionStyle = {
			marginBottom: 48,
			padding: 20,
			border: "1px solid #e0e0e0",
			borderRadius: 8,
			backgroundColor: "#fafafa",
		};

		const headingStyle = {
			margin: "0 0 16px 0",
			fontSize: "16px",
			fontWeight: "600",
			color: "#333",
		};

		const contentStyle = {
			fontSize: "14px",
			lineHeight: "1.5",
			color: "#666",
		};

		return (
			<div style={{ paddingLeft: 24, paddingRight: 24, maxWidth: 800 }}>
				<div style={sectionStyle}>
					<h4 style={headingStyle}>Bulk Download Override</h4>
					<LabeledDropDownSelect
						isClearable
						placeholder="Disabled (LxW API Server will use value from backend.config.json)"
						label="Override Bulk Download Server"
						options={bulkDownloadOverrideOptions}
						defaultValue={this.getDefaultBulkDownloadOverrideDropdownValue()}
						name="bulkDownloadServerAuthority"
						handler={this.handleChange}
					/>
				</div>

				<div style={sectionStyle}>
					<h4 style={headingStyle}>Show Developer Messages</h4>
					<LabeledDropDownSelect
						isClearable
						placeholder="No Developer Messages will be shown"
						label="Show Developer Messages"
						options={showDeveloperMessagesOptions}
						defaultValue={this.getDefaultDevloperMessageDropdownValue()}
						name="showDeveloperMessages"
						handler={this.handleChange}
					/>
					{shouldShowDeveloperMessages(
						this.props.developerOverrides.showDeveloperMessages
					)
						? showAsDeveloperMessage("Example Developer Message")
						: null}
				</div>

				<div style={sectionStyle}>
					<h4 style={headingStyle}>Override Frontend User Rights</h4>
					<div style={{ marginBottom: 16 }}>
						This only overrides the frontend user rights, which
						determine whether certain actions are allowed on the
						frontend. It does not change any backend backend
						rights/permissions.
					</div>
					<LabeledDropDownSelect
						isClearable
						placeholder="Normal user rights from permissions will be used"
						label="Override Frontend User Rights"
						options={overrideFrontendUserRightsOptions}
						defaultValue={this.getDefaultOverrideFrontendUserRightsDropdownValue()}
						name="overrideFrontendUserRights"
						handler={this.handleChange}
					/>
				</div>

				<div style={sectionStyle}>
					<h4 style={headingStyle}>
						Ignore Trash/Archive Lifecycle Disabled States
					</h4>
					<div style={{ marginBottom: 16 }}>
						When enabled, items in the Trash or Archive will not
						have their actions disabled on the frontend. Does not
						bypass backend checks.
					</div>
					<LabeledDropDownSelect
						isClearable
						placeholder="Disabled (normal trash/archive behavior)"
						label="Ignore Lifecycle Status"
						options={ignoreLifecycleStatusOptions}
						defaultValue={this.getDefaultIgnoreLifecycleStatusDropdownValue()}
						name="ignoreLifecycleStatus"
						handler={this.handleChange}
					/>
				</div>

				<div style={sectionStyle}>
					<h4 style={headingStyle}>API Configuration</h4>
					<div style={contentStyle}>
						{this.props.developerOverrides.apiName !==
						"OVERRIDE_DISABLED" ? (
							<div>
								The LexWorkplace Frontend is currently
								configured to use an API other than the default
								for this environment:{" "}
								<strong>
									{`"${this.props.developerOverrides.apiName}"`}
								</strong>
								.
								<br />
								<br />
								The default API for each environment is
								configured in the frontend config files:{" "}
								<pre
									style={{
										display: "inline",
										backgroundColor: "#f0f0f0",
										padding: "2px 4px",
										borderRadius: 3,
									}}
								>{`config/<environment_name>.frontend.config.json`}</pre>
								<br />
								<br />
								Run{" "}
								<pre
									style={{
										display: "inline",
										backgroundColor: "#f0f0f0",
										padding: "2px 4px",
										borderRadius: 3,
									}}
								>{`npm run setConfig <environment_name> <environment_name>`}</pre>{" "}
								to set the frontend to use any of the allowed
								APIs.
							</div>
						) : (
							<div>
								The LexWorkplace Frontend is configured to use
								its normal API, set in{" "}
								<pre
									style={{
										display: "inline",
										backgroundColor: "#f0f0f0",
										padding: "2px 4px",
										borderRadius: 3,
									}}
								>{`config/<environment_name>.frontend.config.json`}</pre>
							</div>
						)}
					</div>
				</div>

				{frontendConfig.usingTunnel ? (
					<div style={sectionStyle}>
						<h4 style={headingStyle}>Database</h4>
						<div style={contentStyle}>
							<div
								style={{
									padding: 16,
									backgroundColor: "#fff3cd",
									border: "1px solid #ffeaa7",
									borderRadius: 4,
								}}
							>
								<strong>Tunnel Active:</strong> The backend is
								running locally but connected to the{" "}
								<strong>{frontendConfig.usingTunnel}</strong>{" "}
								database through an SSH tunnel.
							</div>
						</div>
					</div>
				) : null}

				<div style={sectionStyle}>
					<h4 style={headingStyle}>Error Boundary Test</h4>
					<div style={contentStyle}>
						<a href="#" onClick={this.handleTriggerTestError}>
							Trigger a test error
						</a>{" "}
						to verify the error boundary page renders correctly.
					</div>
				</div>

				<div style={sectionStyle}>
					<h4 style={headingStyle}>Build Information</h4>
					<div style={contentStyle}>
						{this.props.developerOverrides.gitBranch !==
						"OVERRIDE_DISABLED" ? (
							<div>
								This hosted environment has been built from
								branch{" "}
								<strong>
									{`"${this.props.developerOverrides.gitBranch}"`}
								</strong>
								.
							</div>
						) : (
							<div>
								If this is a hosted environment, it has been
								built from its usual branch.
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		developerOverrides: state.developerOverrides,
	};
};
export default connect(mapStateToProps, {
	setDeveloperOverride,
})(DeveloperOverridesSettings);
